import { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';
import './container.scss';

const Container = ({
  className,
  children,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div {...props} className={classNames(className, 'quipli-container')}>
      {children}
    </div>
  );
};

export default Container;
